"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.standardReplacements = void 0;
exports.standardReplacements = {
    rssi: 'RSSI',
    snr: 'SNR',
    sf: 'SF',
    dr: 'DR',
    adr: 'ADR',
    esp: 'ESP',
    asf: 'ASF',
    iotv: 'IoTV',
    ssac: 'SSAC',
    ULrDL: 'Uplinks to Downlink Ack',
    DMissL: 'Missed Downlink Count',
    MaxSF: 'Max SF',
};
